import { Box } from '@mui/material'
import { InternalUseOnlyCheckbox } from '../InternalUseOnlyCheckbox'
import { FFInput } from '~/shared/ui'
import TasksForm from './TasksForm'
import { CarePlanModalTask } from './useCarePlanModal'
import { format } from 'date-fns'
import { ISO_DATE_FORMAT } from '~/shared/lib/date'
import type { PatientUser } from '~/shared/types'
import type { RootState } from '~/app/store/configureStore'

interface IEditOrCustomCreateForm {
  me: RootState['me']
  patient: PatientUser
  tasks: CarePlanModalTask[]
  setTasks: (arg0: CarePlanModalTask[]) => void
  saving: boolean
  title: string
  notes: string
  setTitle: (arg0: string) => void
  setNotes: (arg0: string) => void
  internalOnly: boolean
  setInternalOnly: (value: boolean) => void
}

const EditOrCustomCreateForm = (props: IEditOrCustomCreateForm) => {
  const addTask = () => {
    const newTasks: CarePlanModalTask[] = [
      ...props.tasks,
      {
        title: '',
        due_date: format(new Date(), ISO_DATE_FORMAT),
        owner_group: props.me.assignee_group?.id,
        priority: 0,
        is_complete: false,
      },
    ]
    props.setTasks(newTasks)
  }

  /**
   * @param {number} i - index of the array of tasks
   */
  const updateTask = (i: number, update: Partial<CarePlanModalTask>) => {
    const newTasks = props.tasks.map((task, index) => (index === i ? { ...task, ...update } : task))
    props.setTasks(newTasks)
  }

  const removeTask = (i: number) => {
    const newTasks = [...props.tasks]
    newTasks.splice(i, 1)
    props.setTasks(newTasks)
  }

  const handleUpdateNotes = (event: React.ChangeEvent<HTMLInputElement | HTMLTextAreaElement>) => {
    if (event) {
      props.setNotes(event.target?.value)
    }
  }

  const handleUpdateTitle = (event: React.ChangeEvent<HTMLInputElement | HTMLTextAreaElement>) => {
    if (event) {
      props.setTitle(event.target?.value)
    }
  }

  return (
    <>
      <FFInput
        disabled={props.saving}
        onChange={e => handleUpdateTitle(e)}
        value={props.title}
        sx={{ mb: 1 }}
        placeholder="Add care plan name"
        fullWidth
        slotProps={{ htmlInput: { maxLength: 255 } }}
      />
      <FFInput
        disabled={props.saving}
        onChange={e => handleUpdateNotes(e)}
        value={props.notes}
        sx={{ mb: 1 }}
        placeholder="Add description"
        multiline={true}
        fullWidth
      />
      <Box sx={{ mb: 1 }}>
        <InternalUseOnlyCheckbox
          checked={props.internalOnly}
          onChange={props.setInternalOnly}
          disabled={props.saving}
        />
      </Box>
      <TasksForm
        patient={props.patient}
        tasks={props.tasks}
        addTask={addTask}
        updateTask={updateTask}
        removeTask={removeTask}
        saving={props.saving}
      />
    </>
  )
}

export default EditOrCustomCreateForm
